export default {
    mounted(el) {
        el.addEventListener("change", () => {
            if (el.value === "") {
                return;
            }
            if (Number(el.value) < 0) {
                const event = new Event("input", { bubbles: true });
                el.value = 0;
                el.dispatchEvent(event);
            }
        });
    },
};
